import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { refreshAccessToken } from '../../lib/api';
import { toast } from '../../store/ui';
import { AuthLayout } from './AuthLayout';
import { restoreSession, useSession } from './session';

const REASONS: Record<string, string> = {
  registration_closed: 'Die Registrierung ist geschlossen – ein neues Konto kann nicht angelegt werden.',
  already_linked: 'Dieses Discord-Konto ist bereits mit einem anderen Konto verknüpft.',
  disabled: 'Dieses Konto ist gesperrt.',
  state: 'Die Anmeldung ist abgelaufen. Bitte erneut versuchen.',
};

/** Rücksprung von Discord OAuth2 (`/auth/discord/done?status=ok|linked|error&reason=…`). */
export function DiscordDoneScreen() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get('status');
  const reason = params.get('reason') ?? '';
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (status === 'linked') {
      toast.success('Discord-Konto verknüpft');
      void navigate('/settings/konto', { replace: true });
      return;
    }
    if (status !== 'ok') return;
    // Login: Refresh-Cookie ist gesetzt → Access-Token holen.
    void refreshAccessToken().then((ok) => {
      if (ok) {
        void restoreSession();
        void navigate('/channels/@me', { replace: true });
      } else {
        useSession.getState().set('anonymous');
        setFailed(true);
      }
    });
  }, [status, navigate]);

  if (status === 'ok' && !failed) return <AuthLayout title="Anmeldung läuft …" testId="discord-done">{null}</AuthLayout>;
  return (
    <AuthLayout title="Discord-Anmeldung fehlgeschlagen" testId="discord-done">
      <p className="error-text" role="alert" data-testid="discord-error">
        {REASONS[reason] ?? (reason ? `Fehler: ${reason}` : 'Unbekannter Fehler.')}
      </p>
      <Link className="btn btn-primary btn-block" to="/login">
        Zur Anmeldung
      </Link>
    </AuthLayout>
  );
}
